import { createSlice } from '@reduxjs/toolkit'

     
let initialState={ 
 setting:{},
 header_pages:[],
 footer_pages:[]
}

export const SettingSlice =  createSlice({
  name: 'setting',
  initialState,
  reducers:{
    setSetting: (state,action) => {
      state.setting=action.payload.settings;
      state.header_pages=action.payload.header_pages;
      state.footer_pages=action.payload.footer_pages;
    },
  },
})
export const {setSetting}=SettingSlice.actions
export default SettingSlice.reducer